// extracted by mini-css-extract-plugin
export default {"footer":"footer-module__footer__1bXt1"};